import { NgModule } from '@angular/core';
import { FileUploadModule } from 'ng2-file-upload';
import { CidadeModule } from '../../cidade';
import { IntegrationClienteSharedModule } from '../../configuracoes/integration/cliente';
import { PessoaModule } from '../pessoa.module';
import { RepresentanteModule } from '../representante';
import { PessoaTermoLGPDFormModule } from '../termo-lgpd/form';
import { ClienteAnaliseFinanceiraStatusBadgeModule } from './analise-financeira/status/badge';
import { ClienteAtendimentoComponent } from './atendimento';
import { ClienteRoutingModule } from './cliente-routing.module';
import { ClienteComponent } from './cliente.component';
import { ClienteDashboardModule } from './dashboard';
import { ClienteExcelModule } from './excel';
import { ClienteFilterModule } from './filter';
import { NovoClienteFilterModule } from './filter/novo-cliente-filter/novo-cliente-filter.module';
import { ClienteFormModule } from './form';
import { ClienteFormModalModule } from './form-modal';
import { ClienteImportModalComponent } from './import-modal';
import { ClienteIntegracaoErpImportModule } from './integracoes/erp/import';
import { ClienteInternetSharedModule } from './internet';
import {
  ClienteItensVendidosComponent,
  ClienteItensVendidosFamiliaComponent,
} from './itens-vendidos';
import { ClienteListModule } from './list';
import { NovoClienteListModule } from './list/novo-cliente-list/novo-cliente-list.module';
import { ClienteListagemReportModalComponent } from './listagem-report-modal';
import { ClienteMatrizSelectComponent } from './matriz';
import { ClienteUnidadeNegocioImportModalModule } from './unidade-negocio/import-modal';
import { ClienteUnidadeNegocio2Module } from './unidade-negocio2';

@NgModule({
  imports: [
    ClienteRoutingModule,
    PessoaModule,
    ClienteFilterModule,
    PessoaTermoLGPDFormModule,
    ClienteInternetSharedModule,
    ClienteUnidadeNegocio2Module,
    ClienteListModule,
    NovoClienteListModule,
    NovoClienteFilterModule,
    ClienteDashboardModule,
    RepresentanteModule,
    CidadeModule,
    ClienteAnaliseFinanceiraStatusBadgeModule,
    IntegrationClienteSharedModule,
    ClienteIntegracaoErpImportModule,
    FileUploadModule,
    ClienteExcelModule,
    ClienteUnidadeNegocioImportModalModule,
    ClienteFormModule,
    ClienteFormModalModule
  ],
  declarations: [
    ClienteComponent,
    ClienteImportModalComponent,

    ClienteItensVendidosComponent,
    ClienteItensVendidosFamiliaComponent,
    ClienteAtendimentoComponent,
    ClienteListagemReportModalComponent,
    ClienteMatrizSelectComponent,
  ],
  exports: [
    ClienteMatrizSelectComponent
  ],
})
export class ClienteModule {}
